import { colors } from '../../../theme';

const checkIfSelected = (key, pathname, subItems) => {
  let page = pathname.split('/')[1];
  if (subItems && subItems.some(item => page === item)) return true;
  if (!page) page = 'dashboard';
  return page === key;
};

const getRoute = key => (key === 'dashboard' ? '' : key);

const getColor = (isSelected, defaultColor) => (isSelected ? colors['green-primary'] : defaultColor);

export const parseInfo = (key, pathname, defaultColor, subItems) => {
  const isSelected = checkIfSelected(key, pathname, subItems);
  const color = getColor(isSelected, defaultColor);
  const route = getRoute(key);
  return { route, color };
};
